import React from 'react';
import styled, { css } from 'styled-components';
import { createTypography } from 'utils';
import ReactMarkdown from 'react-markdown';

export const RichTextWrapper = styled.div`
  h1 {
    ${createTypography('h1', 'md')}
    color: ${({ theme }) => theme.palette.blackLighten5};

    &:not(:last-child) {
      margin-bottom: 3.2rem;
    }

    ${({ theme }) => theme.breakpoints.maxTablet} {
      ${createTypography('h1', 'sm')};
      &:not(:last-child) {
        margin-bottom: 1.6rem;
      }
    }
  }

  h2 {
    ${createTypography('h2', 'md')}

    &:not(:last-child) {
      margin-bottom: 3.2rem;
    }

    ${({ theme }) => theme.breakpoints.maxTablet} {
      ${createTypography('h2', 'sm')};
      &:not(:last-child) {
        margin-bottom: 1.6rem;
      }
    }
  }

  p {
    ${({ paragraphSize }) => createTypography('p', paragraphSize?.desktop || 'md')};

    ${({ paragraphBlack, theme }) =>
      paragraphBlack &&
      css`
        color: ${theme.palette.blackLighten5};
      `}

    &:not(:last-child) {
      margin-bottom: 3.2rem;
    }

    ${({ theme }) => theme.breakpoints.maxMobile} {
      ${({ paragraphSize }) => createTypography('p', paragraphSize?.mobile || 'sm')};

      &:not(:last-child) {
        margin-bottom: 1.6rem;
      }
    }
  }

  img {
    max-width: 100%;
  }
`;

export const RichText = ({ paragraphBlack, paragraphSize, children, className }) => (
  <RichTextWrapper
    className={className}
    paragraphBlack={paragraphBlack}
    paragraphSize={paragraphSize || 'md'}
  >
    <ReactMarkdown source={children} />
  </RichTextWrapper>
);
